<div class="padding">
  <b>Image gallery</b>

  <div class="flex center">
    <div
      class="circle flex center justify-center bg-primary-dark white hover {{ isFirst() ? 'disabled' : '' }}"
      (click)="goPrevious()"
    >
      <i class="fa fa-solid fa-arrow-left"></i>
    </div>

    <div class="flex padding">
      @for (shot of shots; track $index) {
        @if (shot.selected) {
          <div class="flex column">
            <div class="flex center margin-top">
              @if (isVideo(shot)) {
                <video [src]="shot.imgPath" class="border bg-light-grey" controls></video>
              } @else {
                <img [src]="shot.imgPath" class="border bg-light-grey" />
              }
            </div>
            <div class="flex column margin-top">
              <div>
                <b>Aspect Ratio:</b>
                {{ shot.aspectRatio.id == 1 ? 'Square' : '-' }} {{ shot.aspectRatio.label }},
                {{ shot.mediaFormat.name }}
              </div>
              <div>
                <b>Filename:</b>
                {{ shot.estimatedFileName }}
              </div>
            </div>
          </div>
        }
      }
    </div>
    <div
      class="circle flex center justify-center bg-primary-dark white hover {{ isLast() ? 'disabled' : '' }}"
      (click)="goNext()"
    >
      <i class="fa fa-solid fa-arrow-right"></i>
    </div>
  </div>

  <div class="flex column end margin-top">
    <div class="flex center">
      <button (click)="close()">
        <i class="fa-solid fa-undo margin-right-smallest"></i>
        Close
      </button>
    </div>
  </div>
</div>
